import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { RequestWrapper } from "../../routers/request-wrapper";
import { Shops, Shop, UpdateShop } from "./pages";

export const ShopsRouter = [
  <Route
    path="/shops"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Shops} />
      </ProtectedRoute>
    }
  />,

  <Route path="/shop">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Shop />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateShop />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const AdminShopsRouter = [
  <Route
    path="/shops"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Shops} />
      </ProtectedRoute>
    }
  />,

  <Route path="/shop">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Shop />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateShop />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const ClientShopsRouter = [
  <Route
    path="/shops"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Shops} />
      </ProtectedRoute>
    }
  />,

  <Route path="/shop">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Shop />
        </ProtectedRoute>
      }
    />
    ,
  </Route>,
];
